import restful from '../vuex'
import axios from 'axios'

const state = {
  ...restful.states('chain_store')
}

const getters = {
  ...restful.getters('chain_store')
}

const actions = {
  ...restful.actions('chain_stores'),
  async find_one ({ commit }) {
    const res = await axios.get('chain_stores/find_one')
    commit('chain_store', res.data)
  },
  async upgrade ({ commit }, params) {
    const res = await axios.post('chain_stores/upgrade', params)
    commit('chain_store', res.data)
  }
}

const mutations = {
  ...restful.mutations('chain_store'),
  chain_store (state, chain_store) {
    state.chain_store = chain_store
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
